"use client";

import { useEffect } from "react";
import Link from "next/link";

export default function MarketingError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Marketing page error:", error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-white">
      <div className="text-center max-w-sm">
        <h2 className="text-xl font-bold text-slate-900 mb-2">Page Error</h2>
        <p className="text-sm text-slate-500 mb-6">Something went wrong loading this page.</p>
        <div className="flex items-center justify-center gap-3">
          <button onClick={reset} className="h-9 px-4 rounded-lg bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700">
            Try Again
          </button>
          <Link href="/home" className="h-9 px-4 rounded-lg border text-sm font-medium hover:bg-slate-50 inline-flex items-center">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
